"use client";

import { c as _c } from "react/compiler-runtime";
import { useActionState, useEffect, useState } from "react";
import { login } from "../actions";
import Form from "next/form";
import InputComponent from "@/components/ui/InputComponent";
import ButtonComponent from "@/components/ui/ButtonComponent";
import { useTranslations } from "next-intl";
import { Link } from "@/features/i18n";
import { TwoFactorCodeModal } from "./two-factor-code-modal";
import { toast } from "sonner";
export function LoginForm() {
  const $ = _c(64);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      email: "",
      password: "",
      error: "",
      needsValidation: false,
      fieldErrors: undefined
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [state, formAction, isPending] = useActionState(login, t0);
  const [isValidationModalOpen, setIsValidationModalOpen] = useState(false);
  const buttons = useTranslations("Buttons");
  const placeholders = useTranslations("Placeholders");
  const labels = useTranslations("Labels");
  const loginText = useTranslations("Login");
  const modals = useTranslations("Modals");
  let t1;
  if ($[1] !== state?.needsValidation) {
    t1 = () => {
      if (state?.needsValidation) {
        setIsValidationModalOpen(true);
      }
    };
    $[1] = state?.needsValidation;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = state?.needsValidation;
  let t3;
  if ($[3] !== t2) {
    t3 = [t2];
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useEffect(t1, t3);
  let t4;
  if ($[5] !== isPending || $[6] !== state) {
    t4 = () => {
      if (!isPending && state?.error) {
        toast.error(state.error);
      }
    };
    $[5] = isPending;
    $[6] = state;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = state?.error;
  let t6;
  if ($[8] !== isPending || $[9] !== t5) {
    t6 = [isPending, t5];
    $[8] = isPending;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  useEffect(t4, t6);
  let t7;
  if ($[11] !== labels) {
    t7 = labels("labelMail");
    $[11] = labels;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== labels) {
    t8 = labels("labelMail");
    $[13] = labels;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== placeholders) {
    t9 = placeholders("placeholderMail");
    $[15] = placeholders;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = state?.email;
  const t11 = state?.fieldErrors?.mail?.[0];
  let t12;
  if ($[17] !== t10 || $[18] !== t11 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t12 = <InputComponent id={t7} type="text" name="email" autoComplete="email" label={t8} isRequired={true} placeholder={t9} defaultValue={t10} className="input--full" error={t11} />;
    $[17] = t10;
    $[18] = t11;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== labels) {
    t13 = labels("labelPassword");
    $[23] = labels;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== labels) {
    t14 = labels("labelPassword");
    $[25] = labels;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== placeholders) {
    t15 = placeholders("placeholderPassword");
    $[27] = placeholders;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  const t16 = state?.password;
  const t17 = state?.fieldErrors?.password?.[0];
  let t18;
  if ($[29] !== t13 || $[30] !== t14 || $[31] !== t15 || $[32] !== t16 || $[33] !== t17) {
    t18 = <InputComponent id={t13} type="password" name="password" autoComplete="current-password" isRequired={true} label={t14} placeholder={t15} defaultValue={t16} className="input--full" error={t17} />;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
    $[32] = t16;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== modals) {
    t19 = modals("requiredFieldsMessage");
    $[35] = modals;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t19) {
    t20 = <p className="auth__required-message">{t19}</p>;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== loginText) {
    t21 = loginText("text-link-forgot-password");
    $[39] = loginText;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] !== loginText) {
    t22 = loginText("link-forgot-password");
    $[41] = loginText;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t22) {
    t23 = <Link href="/send-reset-email" className="auth__link-primary">{t22}</Link>;
    $[43] = t22;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== t21 || $[46] !== t23) {
    t24 = <p className="auth__forgot-password">{t21}{" "}{t23}</p>;
    $[45] = t21;
    $[46] = t23;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== buttons) {
    t25 = buttons("buttonLogin");
    $[48] = buttons;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== isPending || $[51] !== t25) {
    t26 = <ButtonComponent type="submit" disabled={isPending} loading={isPending}>{t25}</ButtonComponent>;
    $[50] = isPending;
    $[51] = t25;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t20 || $[54] !== t24 || $[55] !== t26) {
    t27 = <section className="login__footer">{t20}{t24}{t26}</section>;
    $[53] = t20;
    $[54] = t24;
    $[55] = t26;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] !== isValidationModalOpen) {
    t28 = <TwoFactorCodeModal isValidationModalOpen={isValidationModalOpen} setIsValidationModalOpen={setIsValidationModalOpen} />;
    $[57] = isValidationModalOpen;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  let t29;
  if ($[59] !== t12 || $[60] !== t18 || $[61] !== t27 || $[62] !== t28) {
    t29 = <Form action={formAction} className="auth__form-base auth__login-form">{t12}{t18}{t27}{t28}</Form>;
    $[59] = t12;
    $[60] = t18;
    $[61] = t27;
    $[62] = t28;
    $[63] = t29;
  } else {
    t29 = $[63];
  }
  return t29;
}